import * as React from 'react';

import { isDevelopment } from '@gitbook/env';

import './splashscreen.css';

let done = false;

/**
 * Hook to hide the splashscreen from the base HTML file when the app is ready.
 */
export function useHideSplashscreen(
    /**
     * Delay before starting animation to hide the splashscreen.
     * If we know the app is ready, we can start the animation immediately by passing 0.
     */
    delay = 800,
    /**
     * If it's the main fallback, and the splashscreen hasn't been removed yet, we throw an error in dev
     * to make sure all routes properly hide it when ready.
     */
    isMainFallback = false
) {
    React.useEffect(() => {
        if (done) {
            return;
        }

        if (delay && !process.env.GITBOOK_PREDICTABLE_UI) {
            const timeout = setTimeout(() => fadeOutSplashscreen(isMainFallback), delay);
            return () => clearTimeout(timeout);
        }
        fadeOutSplashscreen();
    }, [delay, isMainFallback]);
}

function fadeOutSplashscreen(isMainFallback = false) {
    if (done) {
        return;
    }

    if (isMainFallback && isDevelopment) {
        throw new Error(
            'Splashscreen was forced to be hidden. Make sure all routes properly hide it when ready using useHideSplashscreen().'
        );
    }

    done = true;

    const splashscreen = document.querySelector('.gitbook-splashscreen');

    if (splashscreen) {
        const cleanup = () => {
            splashscreen.remove();
        };

        // @ts-ignore - `startViewTransition` is not typed yet
        if (process.env.GITBOOK_PREDICTABLE_UI || !document.startViewTransition) {
            return cleanup();
        }

        // @ts-ignore - `startViewTransition` is not typed yet
        document.startViewTransition(cleanup);
    }
}
